import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const location = useLocation();
  useEffect(() => {
    const run = () => {
      if (location.hash) {
        const el = document.getElementById(location.hash.slice(1));
        if (el) { el.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
      }
      window.scrollTo(0, 0);
    };
    run();
    const t = setTimeout(run, 150);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.key, location.pathname, location.hash]);
  return null;
};

export default ScrollToTop;
